import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ErrorDetailsActions } from './error-details.actions';
import { ActiveDeviceError } from './error-details.model';
import { ErrorDetailsSelectors } from './error-details.selectors';

@Injectable({ providedIn: 'root' })
export class ErrorDetailsStore {
  state$ = this.store.select(ErrorDetailsSelectors.getState());
  loading$ = this.store.select(ErrorDetailsSelectors.loading);
  allErrorsDetails$ = this.store.select(ErrorDetailsSelectors.getAllErrorsDetails());
  allErrorsDetailsLoading$ = this.store.select(ErrorDetailsSelectors.allErrorsDetailsLoading);
  allErrorsDetailsLoaded$ = this.store.select(ErrorDetailsSelectors.allErrorsDetailsLoaded);

  searchErrorDetails(
    boilerSerial: string,
    errorCode: string,
    countryCode: string,
    languageCode: string
  ): void {
    this.store.dispatch(
      ErrorDetailsActions.getErrorDetails.attempt({
        materialNumber: boilerSerial,
        errorCode,
        countryCode,
        languageCode,
      })
    );
  }

  getAllErrorsDetails(shortBoilerSerial: string, countryCode: string, languageCode: string): void {
    this.store.dispatch(
      ErrorDetailsActions.getAllErrorsDetails.attempt({
        materialNumber: shortBoilerSerial,
        countryCode,
        languageCode,
      })
    );
  }

  getFullError(errorCode: string, languageCode: string): Observable<ActiveDeviceError> {
    return this.store.select(ErrorDetailsSelectors.getFullError(errorCode, languageCode));
  }

  clearErrorState(): void {
    this.store.dispatch(ErrorDetailsActions.clearState());
  }

  constructor(private store: Store) {}
}
